module.exports = __webpack_public_path__ + "static/assets/40919cee701a9297cd1e90595c089544.png";